import SEOHead from "@/components/General/SEOHead";
import BlogDetail from "@/modules/Blogs/BlogDetail";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { fetchContent } from "@/lib/server-content";
import { jsonBody } from "@/lib/seo";
export default function BlogDetailPage() {
  return (
    <div className="bg-white py-4">
      <SEOHead />
      <BlogDetail />
    </div>
  );
}
export async function getServerSideProps({ locale = "ar", params }: any) {
  if (!/^\d+$/.test(params.id)) return { notFound: true };
  const article = await fetchContent("blogs", locale, params.id);
  if (!article) return { notFound: true };
  if (article.lang !== locale) {
    const translatedId = jsonBody(article).translationIds?.[locale];
    if (!translatedId) return { notFound: true };
    return {
      redirect: {
        destination: `${locale === "en" ? "/en" : ""}/blogs/${translatedId}`,
        permanent: true,
      },
    };
  }
  return {
    props: { article, ...(await serverSideTranslations(locale, ["common"])) },
  };
}
